//TODO
//This component should work for Add new Product Group and for Edit a existing Product Group

//Fields should validate the input
//Required fields at ProductGroupViewModel.cs
//Name (min 3, max 50), Description, Status, ProductId(List), ProductCategoryIds(List)

//TODO
//Clean forms when Component unmount.
//TO THINK- 
//WHY I have to save the form input value to the store? I dont neet to share that information to
//Any other component outside of this tree. This is really necessary?

//qustion is how to change, it was already there now its too much maybe. One option is to create a library and slowly change or use material ui direct and stop using the components
// maybe pass a form variable to all inputs and assing to state? inside the exisitng TExtInput for example, if form exists use assign there and stop sending to the store

import React, { Component } from 'react';
import { connect } from 'react-redux';
import CardSimple from 'screens/components/basic/CardSimple';
import LOOKUP from 'constants/lookup';
import Button from 'screens/components/basic/Button';
import TextInput from 'screens/components/basic/TextInput';
import ToggleInput from 'screens/components/basic/ToggleInput';
import { initializeCarouselProductGroupForm, updateProductCampaigns, clearDialogItemsProductGroup, formError, clearFormInput } from 'actions/FormActions';
import RadioInput from 'screens/components/basic/RadioInput';
import GenericTable from 'screens/components/advanced/GenericTable';
import Pagination from 'screens/components/basic/Pagination';
import * as types from 'constants/actionTypes';
import { getCategories, getProductsCarousel, saveProductGroup, getProductGroupById, getPriceMatrices, clearProductsCarousel, getHomeSettings, updateHomeSettings, getProductGroupHome, getAllOnlineCampaigns } from 'actions/EntityActions';
import { selectCarouselForm, selectCampaignSelectedCategories, selectedCampaigns } from 'selectors/entitySelector';
import DatePickerCalendarInput from 'screens/components/basic/DatePickerCalendarInput';
import DialogInput from 'screens/components/advanced/DialogInput';
import SelectInput from 'screens/components/basic/SelectInput';
import CheckInput from 'screens/components/basic/CheckInput';
import util from 'library/util';
import Grid from 'screens/components/basic/Grid';
import { carouselAddCrumb, carouselEditCrumb } from 'utils/breadcrumbInfo';
import { showError } from 'actions/CommonActions';
import DialogHeader from 'screens/components/basic/DialogHeader';
import WithRouter from 'custom/withRouter';

const componentName = "carouselSave";
class carouselSave extends Component {

    constructor(props) {
        super(props);

        this.state = {
            productList: [],
            categoryList: [],
            productListEdit: [],
            categoryListEdit: [],
            campaignListEdit: [],
            activePage: 1,
            itemsPerPage: 25,
            status: "",
            dialogProducts: false,
            menuId: 0,
            errorNoAddedItems: false,
            newCarousel: {},
            selectedProductGroup: []
        };
    }

    componentWillMount() {
        const menuId = this.props.params.id;
        if (menuId) {
            this.setState({ status: "EDIT", menuId: menuId });
            this.props.getProductGroupById({
                id: menuId,
                branchId: this.props.branchId,
                compName: componentName
            });
        }
        else {
            this.setState({ status: "ADD" });
            this.props.init(this.props.name);
            this.props.getHomeSettings(this.props.branchId);
        }
        this.props.getCategories();
        this.props.getAllOnlineCampaigns({
            branchId: this.props.branchId
        });
        this.props.getPriceMatrices();

        if (!this.props.productGroupList.list) {
            this.props.getProductGroupHome({
                branchId: this.props.branchId,
                page: 1,
                itemsPerPage: 25
            });
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.products) {
            if (newProps.products.length > 0 && newProps.products !== this.props.products) {
                this.setState(prevState => {
                    return {
                        ...prevState,
                        productList: [...newProps.products]
                    };
                });
            }
        }

        if (newProps.productsListEdit) {
            if (newProps.productsListEdit.length > 0 && newProps.productsListEdit !== this.props.productsListEdit) {
                this.productSelected(newProps.productsListEdit);
            }
        }

        if (newProps.categoriesListEdit) {
            if (newProps.categoriesListEdit.length > 0 && newProps.categoriesListEdit !== this.props.categoriesListEdit) {
                this.setState(prevState => {
                    return {
                        ...prevState,
                        categoryListEdit: [...newProps.categoriesListEdit]
                    };
                });
            }
        }

        if (newProps.campaignsListEdit) {
            if (newProps.campaignsListEdit.length > 0 && newProps.campaignsListEdit !== this.props.campaignsListEdit) {
                this.setState(prevState => {
                    return {
                        ...prevState,
                        campaignListEdit: [...newProps.campaignsListEdit]
                    };
                });
            }
        }

        if (newProps.homeSettingsUpdated != undefined && newProps.homeSettingsUpdated !== this.props.homeSettingsUpdated) {

            if (newProps.homeSettingsUpdated) {
                this.redirectToMenu();
            } else {
                this.saveFailure();
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.newCarousel && prevProps.newCarousel !== this.props.newCarousel) {
            this.setState(prevState => {
                return {
                    ...prevState,
                    newCarousel: this.props.newCarousel
                };
            }, this.saveHome);
        }
    }

    componentWillUnmount() {
        this.props.init(this.props.name);
        this.props.clearProductsCarousel();
    }

    saveHome = () => {
        const newCarousel = this.state.newCarousel;
        let selectedProductGroup = [];
        if (this.props.productGroupList.list) {
            for (let i = 0; i < this.props.productGroupList.list.length; i++) {
                if (this.props.homeSettingList) {
                    for (let j = 0; j < this.props.homeSettingList.length; j++) {
                        if (this.props.productGroupList.list[i].id == this.props.homeSettingList[j].productGroupId) {
                            const productGroup = {
                                description: this.props.productGroupList.list[i].description,
                                name: this.props.productGroupList.list[i].name,
                                productGroupId: this.props.productGroupList.list[i].id,
                                id: this.props.homeSettingList[j].id,
                                order: this.props.homeSettingList[j].order
                            }
                            selectedProductGroup.push(productGroup);
                        }
                    }
                }

            }
        } else {
            this.props.navigate("/ecommerce/carousel")
        }


        selectedProductGroup.sort((a, b) => a.order - b.order);

        let ListItems = selectedProductGroup.map((item, index) => {
            return {
                id: typeof item.id === 'number' ? item.id : 0,
                productGroupId: item.productGroupId,
                order: index
            }
        });

        let maxId = ListItems.length > 0 ? Math.max(...ListItems.map(item => item.id)) : 0;
        let maxOrder = ListItems.length > 0 ? ListItems[ListItems.length - 1].order : 0;
        let newItem;

        if (newCarousel) {
            newItem = {
                id: maxId + 1,
                productGroupId: newCarousel.id,
                order: maxOrder + 1
            };
        }

        ListItems = [...ListItems, newItem];

        const settingViewModel = {
            carouselProductGroupId: this.props.productGroupList && this.props.productGroupList.list && this.props.productGroupList.list.length > 0 ? this.props.productGroupList.list[0].id : 1,
            ListItems: ListItems
        }

        this.props.updateHomeSettings({
            branchId: this.props.branchId,
            settingViewModel: settingViewModel,
            compName: componentName
        })
    }

    saveFailure = () => {
        this.props.showPatientError(LOOKUP.ecommerce.carousel.messages.saveErrorMessage);
    }

    productSelected = (products) => {
        this.setState(prevState => {
            return {
                ...prevState,
                productListEdit: products
            };
        });
    }

    redirectToMenu() {
        this.props.navigate('/ecommerce/carousel');
    }

    // function to add the products to the menu
    addProductToMenu = (product) => {
        let products = this.state.productListEdit;
        products.push(product);
        this.setState(prevState => {
            return {
                ...prevState,
                productListEdit: [...products]
            };
        }, this.validateItems);
    }

    removeProduct = (product) => {
        const products = this.state.productListEdit.filter(p => p.id !== product.id);
        this.setState(prevState => {
            return {
                ...prevState,
                productListEdit: [...products]
            };
        });
    }

    addCategoriesToMenu = () => {
        const categories = this.props.categoriesList.filter(c => this.props.selectedCategoriesIds.indexOf(c.id) !== -1);
        this.setState(prevState => {
            return {
                ...prevState,
                categoryListEdit: [...categories]
            };
        }, this.validateItems);
        this.closeProductsDialog();
    }

    addCampaignToMenu = () => {
        const campaigns = this.props.campaignsList.filter(c => this.props.selectedCampaignIds.indexOf(c.id) !== -1);
        this.setState(prevState => {
            return {
                ...prevState,
                campaignListEdit: [...campaigns]
            };
        }, this.validateItems);
        this.closeProductsDialog();
        this.props.updateProductCampaigns(campaigns, componentName);
    }

    removeCategory = (category) => {
        const categories = this.state.categoryListEdit.filter(p => p.id !== category.id);
        this.setState(prevState => {
            return {
                ...prevState,
                categoryListEdit: [...categories]
            };
        });
    }

    removeCampaign = (campaign) => {
        const campaigns = this.state.campaignListEdit.filter(p => p.id !== campaign.id);
        this.setState(prevState => {
            return {
                ...prevState,
                campaignListEdit: [...campaigns]
            };
        });
    }

    // change the page on Add Products to Menu table
    changePage = e => {
        this.setState({ activePage: e }, this.searchProducts);
    }

    openProductsDialog = () => {
        this.setState({ dialogProducts: true });
    }

    closeProductsDialog = () => {
        this.setState({ dialogProducts: false });
        this.props.clearDialogItemsProductGroup(componentName);
    }

    clearFilter = () => {
        this.props.clearDialogItemsProductGroup(componentName);
    }

    saveMenu = (isError) => {     
        if (!isError) {
            let menu = this.props.menuModel;

            const validators = [
                [`${componentName}Name`, menu => (menu.Name && menu.Name !== null && menu.Name !== ""), "Name"],
                [`${componentName}Description`, menu => (menu.Description && menu.Description !== null && menu.Description !== 0), "Description"]
            ];

            const isFormValid = util.validate(validators, menu, this.props.formError);
            const isItemsValid = this.validateItems();

            if (isItemsValid && isFormValid) {
                menu.Id = this.state.menuId;
                menu.ProductIds = this.state.productListEdit.map(item => parseInt(item.id));
                menu.ProductCategoryIds = this.state.categoryListEdit.map(item => parseInt(item.id));
                menu.ProductCampaignIds = this.state.campaignListEdit.map(item => parseInt(item.id));

                this.props.saveProductGroup({
                    branchId: this.props.branchId,
                    productGroupViewModel: menu,
                    compName: componentName
                });
            }
            return;
        }

        const selectField = document.querySelector('[id="date-input"]');
        if (selectField) {
            selectField.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    };

    searchProducts = () => {
        if (this.props.productSearchText
            || this.props.categoryIdSearch
            || this.props.poSearchText
            || this.props.skuSearchText
            || this.props.brandSearchText
            || this.props.weightSearch) {
            const model = {
                page: this.state.activePage,
                itemsPerPage: this.state.itemsPerPage,
                searchText: this.props.productSearchText,
                categoryId: this.props.categoryIdSearch,
                priceMatrixId: this.props.priceMatrixIdSearch,
                branchId: this.props.branchId,
                sku: this.props.skuSearchText,
                poNumber: this.props.poSearchText,
                brandSearchText: this.props.brandSearchText,
                WeightPerUnit: this.props.weightSearch,
                weightStatus: (this.props.weightSearch === null) ? 0 : 1,
            };
            this.props.getProducts(model);
        }
        else {
            this.props.showError(
                <div>
                    <p>It is necessary to enter one of these fields for search: Product Name, Category, SKU, Brand, Weight, PO </p>
                </div>
            )
        }
    }

    search = () => {
        this.setState({ activePage: 1 }, this.searchProducts);
    }

    redirectToCampaignList = () => {
        this.props.navigate('/ecommerce/carousel');
    }

    validateItems = () => {
        const isValid = (this.state.productListEdit.length > 0 || (this.state.categoryListEdit.length > 0) || (this.state.campaignListEdit.length > 0));
        this.setState(prevState => {
            return {
                ...prevState,
                errorNoAddedItems: !isValid
            };
        });
        return isValid;
    }

    selectAllProducts = () => {
        let productListEdit = this.state.productListEdit;
        this.props.productsAll.map((item) => {
            if (productListEdit.filter(x => x.id == item.id).length == 0) {
                productListEdit.push(item);
            }
        });
        this.setState({ categoryListEdit: [], campaignListEdit: [], productListEdit: productListEdit }, this.validateItems);
    }

    genericTableLayout2(myList, columns) {
        return <div className="row">
            <div className="col-lg-12">
                <label className="pb-1">{this.props.addToMenuType == 1 ? 'Categories' : 'Products'} Added: </label>
                <GenericTable
                    compName="productsAddedTable"
                    className="menu_added_table tableHeaderwhiteColorFont"
                    adjustForCheckbox={false}
                    displaySelectAll={false}
                    displayRowCheckbox={false}
                    enableSelectAll={false}
                    multiSelectable={false}
                    selectable={false}
                    columns={columns}
                    rows={myList}
                    stripedRows={true}
                />
            </div>
        </div>;
    }

    addByCategoryLayout() {
        return <div className="row">
            {this.props.categoriesList.map((item, index) => {
                return (
                    <div className="col-lg-6" key={index}>
                        <CheckInput
                            name={`${componentName}ProductCategory-` + item.id}
                            text={item.name}
                            className="selectCampaignItems"
                            value={item.id}
                        />
                    </div>
                );
            })}
            <div className="col-lg-12">
                <br />
                <Button
                    className="pull-right"
                    name="buttonAddItem"
                    label="Add to Carousel"
                    primary={true}
                    onTouchTap={() => this.addCategoriesToMenu()}
                />
            </div>

        </div>;
    }

    addByCampaignLayout() {
        return <div className="row">
            {this.props.campaignsList.map((item, index) => {
                return (
                    <div className="col-lg-6" key={index}>
                        <CheckInput
                            name={`${componentName}ProductCampaign-` + item.id}
                            text={item.name}
                            className="selectCampaignItems"
                        />
                    </div>
                );
            })}
            <div className="col-lg-12">
                <br />
                <Button
                    className="pull-right"
                    name="buttonAddItem"
                    label="Add to Carousel"
                    primary={true}
                    onTouchTap={() => this.addCampaignToMenu()}
                />
            </div>
        </div>;
    }

    addByProductLayout(categories, priceMatrices, productAddList, weights) {
        return <div>
            <div className="row">
                <div className="col-xs-10 col-sm-12 col-md-8 col-lg-6 col-xl-6">
                    <TextInput
                        name={`${componentName}ProductSearchText`}
                        label={LOOKUP.campaign.filters.productName.label}
                        floatingLabelText={LOOKUP.campaign.filters.productName.label}
                        hintText={LOOKUP.campaign.filters.productName.hintText}
                        maxLength={50}
                        fullWidth={true}
                    />
                </div>
                <div className="col-lg-6">
                    <Button
                        className="pull-right mb-1 ml-2"
                        name="searchProductDialog"
                        label="Search"
                        style={{ width: `100px` }}
                        primary={true}
                        onTouchTap={() => this.search()}
                    />
                    <Button
                        className="pull-right mb-2 ml-2"
                        name="buttonAddItem"
                        label={<span style={{ whiteSpace: `nowrap`, color: `white` }}>SELECT ALL</span>}
                        style={{ width: `100px` }}
                        primary={true}
                        onTouchTap={() => this.selectAllProducts()}
                    />
                    <Button
                        className="pull-right mb-2 ml-2"
                        name="buttonClearItem"
                        label={<span style={{ whiteSpace: `nowrap`, color: `white` }}>Clear Filter</span>}
                        style={{ width: `110px` }}
                        primary={true}
                        onTouchTap={() => this.clearFilter()}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <TextInput
                        name={`${componentName}PoSearchText`}
                        label={LOOKUP.campaign.filters.po.label}
                        floatingLabelText={LOOKUP.campaign.filters.po.label}
                        hintText={LOOKUP.campaign.filters.po.hintText}
                        maxLength={50}
                        fullWidth={true}
                    />
                </div>
                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-3 col-xl-4 input_no_padding">
                    <SelectInput name={`${componentName}CategoryIdSearch`}
                        label={LOOKUP.product.filters.category.label}
                        floatingLabelText={LOOKUP.product.filters.category.label}
                        hintText={LOOKUP.product.filters.category.hintText}
                        className="smallerPlaceholder"
                        options={categories}
                        fullWidth={true}
                    />
                </div>
                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-3 col-xl-4 input_no_padding">
                    <SelectInput name={`${componentName}PriceMatrixSearch`}
                        label={LOOKUP.product.priceMatrix.label}
                        floatingLabelText={LOOKUP.product.priceMatrix.label}
                        hintText={LOOKUP.product.priceMatrix.hintText}
                        className="smallerPlaceholder"
                        options={priceMatrices}
                        fullWidth={true}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <TextInput
                        name={`${componentName}SkuSearchText`}
                        label={LOOKUP.campaign.filters.productSku.label}
                        floatingLabelText={LOOKUP.campaign.filters.productSku.label}
                        hintText={LOOKUP.campaign.filters.productSku.hintText}
                        maxLength={50}
                        fullWidth={true}
                    />
                </div>
                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-3 col-xl-4 input_no_padding">
                    <TextInput
                        name={`${componentName}BrandSearchText`}
                        label={LOOKUP.campaign.filters.brand.label}
                        floatingLabelText={LOOKUP.campaign.filters.brand.label}
                        hintText={LOOKUP.campaign.filters.brand.hintText}
                        maxLength={50}
                        fullWidth={true}
                    />
                </div>
                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-3 col-xl-4 input_no_padding">
                    <SelectInput name={`${componentName}WeightSearch`}
                        label={LOOKUP.product.weight.label}
                        floatingLabelText={LOOKUP.product.weight.label}
                        hintText={LOOKUP.product.weight.hintText}
                        className="smallerPlaceholder"
                        options={weights}
                        fullWidth={true}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <GenericTable
                        className="table_center tableHeaderwhiteColorFont"
                        compName="productDialogListTable"
                        adjustForCheckbox={false}
                        displaySelectAll={false}
                        displayRowCheckbox={false}
                        enableSelectAll={false}
                        multiSelectable={false}
                        selectable={false}
                        columns={LOOKUP.campaign.productGroupAddedTableColumns}
                        rows={productAddList}
                        stripedRows={true}
                    />
                    <Pagination
                        length={this.props.productsLength || 0}
                        itemsPerPage={this.state.itemsPerPage}
                        activePage={this.state.activePage}
                        onPageChange={(e) => this.changePage(e)}
                    />
                </div>
            </div>
        </div>;
    }

    render() {
        const p = this.props;
        const breadCrumbPage = this.state.status === 'EDIT' ? carouselEditCrumb : carouselAddCrumb

        const productAddList = (this.props.products || []).map((item, index) => {
            return {
                sku: item.sku,
                name: item.name,
                category: item.category,
                type: item.type,
                icons: (this.state.productListEdit || []).filter(p => p.id == item.id).length > 0
                    ? (
                        <Button
                            key={index}
                            name={`${componentName}${item.id}RemoveItemFromCampaign`}
                            type="IconCheckButton"
                            className="campaign_add_btn_clicked"
                            onTouchTap={() => this.removeProduct(item)}
                        />
                    )
                    : (
                        <Button
                            key={index}
                            name={`${componentName}${item.id}AddProductToMenu`}
                            type="IconCheckButton"
                            className="campaign_add_btn"
                            onTouchTap={() => this.addProductToMenu(item)}
                        />
                    )
            };
        });

        const myProductList = (this.state.productListEdit || []).map((item, index) => {
            return {
                name: item.name,
                category: item.category,
                type: item.type,
                icons:
                    <Button
                        key={index}
                        name={`${componentName}${item.id}RemoveProductFromMenu`}
                        type="IconRemoveButton"
                        onTouchTap={() => this.removeProduct(item)}
                    />
            };
        });

        const myCategoryList = (this.state.categoryListEdit || []).map((item, index) => {
            return {
                name: item.name,
                icons:
                    <Button
                        key={index}
                        name={`${componentName}${item.id}RemoveCategoryFromMenu`}
                        type="IconRemoveButton"
                        onTouchTap={() => this.removeCategory(item)}
                    />
            };
        });

        let categories = (this.props.categoriesList || []).map(c => ({
            text: c.name,
            value: c.id.toString()
        }));

        const myCampaignList = (this.state.campaignListEdit || []).map((item, index) => {
            return {
                name: item.name,
                icons:
                    <Button
                        key={index}
                        name={`${componentName}${item.id}RemoveCampaignFromMenu`}
                        type="IconRemoveButton"
                        className="glyphicon glyphicon-remove-circle"
                        onTouchTap={() => this.removeCampaign(item)}
                    />
            };
        });

        let priceMatrices = (this.props.priceMatrices || []).map(p => ({
            text: p.name,
            value: p.id.toString()
        }));

        let weights = [{ text: "All", value: "none" }];
        LOOKUP.POSWeightList.map((item) => {
            weights.push({
                text: item.label,
                value: item.value
            });
        });

        // Calculate the min and max dates for carousel
        const currentDate = new Date();
        const minYears = 1;  // number of years the date picker will go back from current date
        const maxYears = 5;  // number of years the date picker will go forward from current date
        const minDate = new Date(currentDate.getFullYear() - minYears, currentDate.getMonth(), currentDate.getDate()).toISOString().slice(0, 10); // Today's date - minYears ago
        const maxDate = `${currentDate.getFullYear() + maxYears}-12-31`;

        // Error checks for carousel dates
        const isDateSet = !!(p.carouselStartDate && p.carouselEndDate);
        const isDateNotSet = (!p.carouselStartDate && !p.carouselEndDate);
        const isDateError = isDateSet && (p.carouselEndDate < p.carouselStartDate);
        const isDateSetError = (isDateSet || isDateNotSet) ? false : (!p.carouselStartDate ? "start" : "end");

        return (
            <Grid headerContent={breadCrumbPage}>
                <CardSimple title={this.state.status === 'EDIT' ? LOOKUP.ecommerce.carousel.carouselEdit.title : LOOKUP.ecommerce.carousel.carouselSave.title} className="paddingForMobileDevices mt-2">
                    <div className="row">
                        <div className="col-lg-6">
                            <TextInput
                                name={`${componentName}Name`}
                                label={LOOKUP.ecommerce.carousel.carouselSave.name}
                                floatingLabelText={LOOKUP.ecommerce.carousel.carouselSave.name}
                                hintText={LOOKUP.ecommerce.carousel.carouselSave.hintText}
                                fullWidth={true}
                                maxLength={50}
                                required
                            />
                        </div>
                        <div className="col-lg-6">
                            <TextInput
                                name={`${componentName}Description`}
                                label={LOOKUP.ecommerce.carousel.carouselSave.description}
                                floatingLabelText={LOOKUP.ecommerce.carousel.carouselSave.description}
                                fullWidth={true}
                                required
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <DatePickerCalendarInput id="date-input"
                                name={`${componentName}CarouselStartDate`}
                                floatingLabelText="Carousel Start Date"
                                fullWidth={true}
                                min={minDate}
                                max={maxDate}
                                errorText={isDateSetError === 'start' && "Please set a Start Date, or clear the End Date"}
                                errorStyle={{ color: '#ed4559', fontFamily: 'Open Sans', fontSize: '16px', fontWeight: 'bold', fontStyle: 'italic', marginTop: '7px' }}
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <DatePickerCalendarInput
                                name={`${componentName}CarouselEndDate`}
                                floatingLabelText="Carousel End Date"
                                fullWidth={true}
                                min={minDate}
                                max={maxDate}
                                errorText={isDateError && "'Carousel End Date' must be greater than 'Carousel Start Date'" || isDateSetError === 'end' && "Please set an End Date, or clear the Start Date"}
                                errorStyle={{ color: '#ed4559', fontFamily: 'Open Sans', fontSize: '16px', fontWeight: 'bold', fontStyle: 'italic', marginTop: '7px' }}
                            />
                        </div>
                        <div className="col-xs-12 col-lg-4">
                            <ToggleInput
                                name={`${componentName}Status`}
                                label={LOOKUP.ecommerce.carousel.carouselSave.status}
                                className="btnToggleLabel"
                            />
                        </div>
                    </div> {/* .row */}
                    <hr />
                    <div className="row-flex justify-content-end">
                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                            <Button
                                type="FloatButton"
                                label="Add Items To Carousel"
                                fullWidth={true}
                                className="bg-light-green"
                                onTouchTap={() => this.openProductsDialog()}
                            />
                            {
                                this.state.errorNoAddedItems ? (
                                    <p className="danger">Is necessary to add at least one item to the product group</p>
                                ) : null
                            }
                        </div>
                    </div>
                </CardSimple>

                {/* MODAL DIALOG */}
                <DialogInput
                    title=
                    {
                        <div className="modal-title p-0">
                            <DialogHeader
                                text="Add To Carousel"
                                classicClass="posDialogClassic"
                            />
                        </div>
                    }
                    modal={true}
                    autoScrollBodyContent={true}
                    style={{ zIndex: '980' }}
                    actions={(
                        <Button
                            name="buttonClose"
                            label="Close"
                            primary={false}
                            className="btnCleanSearch btnCloseCarousels"
                            onTouchTap={() => this.closeProductsDialog()}
                        />
                    )}
                    contentStyle={{ width: '95%', maxWidth: 'none' }}
                    open={this.state.dialogProducts}>
                    <div>
                        <div className="row">
                            <div className="col-lg-12">
                            <h3 className="mt-2 purpleText">Add {  this.props.addToMenuType == 1 ? 'Categories' : this.props.addToMenuType == 2 ? 'Products' :this.props.addToMenuType == 3 ? 'Campaign' : ''} to Carousel</h3>
                                <RadioInput
                                    groupName={`AddToMenuType`}
                                    className="pos_refund_radio rdBtnLabels"
                                    options={[
                                        { text: `Add by Category`, value: `1` },
                                        { text: `Add by Product`, value: `2` },
                                        { text: `Add by Campaign`, value: `3` }]
                                    }
                                    fullWidth={true}
                                />
                            </div>
                        </div>
                        <hr />
                        {
                            this.props.addToMenuType == 1
                                ? this.addByCategoryLayout()
                                : null
                        }
                        {
                            this.props.addToMenuType == 2
                                ? this.addByProductLayout(categories, priceMatrices, productAddList, weights)
                                : null
                        }
                        {
                            this.props.addToMenuType == 3
                                ? this.addByCampaignLayout()
                                : null
                        }
                    </div>
                </DialogInput>

                <br />
                <CardSimple title="Products added to Carousel" className="paddingForMobileDevices">
                    <br />
                    {
                        (this.state.productListEdit.length > 0)
                            ? this.genericTableLayout2(myProductList, LOOKUP.campaign.productGroupAddedTableColumns)
                            : <div><p className='purpleText'>No Products added to this Carousel</p></div>
                    }
                </CardSimple>
                <br />
                <CardSimple title="Categories added to Carousel" className="paddingForMobileDevices">
                    <br />
                    {
                        (this.state.categoryListEdit.length > 0)
                            ? this.genericTableLayout2(myCategoryList, LOOKUP.campaign.categoryAddedTableColumns)
                            : <div><p className='purpleText'>No Categories added to this Carousel</p></div>
                    }
                </CardSimple>
                <br />
                <CardSimple title="Campaign added to Carousel" className="paddingForMobileDevices">
                    <br />
                    {
                        (this.state.campaignListEdit.length > 0)
                            ? this.genericTableLayout2(myCampaignList, LOOKUP.campaign.campaignAddedTableColumns)
                            : <div><p className='purpleText'>No Campaigns added to this Carousel</p></div>
                    }
                </CardSimple>
                <br/>
                <div className="row marginRightMobile">
                    <div className="col-lg-12">
                        <Button
                            name="buttonSave"
                            className="pull-right btnNewBrandPOS"
                            label={LOOKUP.campaign.controls.saveButon}
                            onTouchTap={() => this.saveMenu(isDateError || isDateSetError)}
                            primary={true}
                        />
                        <Button
                            name="buttonCancel"
                            className="pull-right btn-space btnCancelOperation"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.redirectToMenu()}
                            type="CancelButton"
                        />
                    </div>
                </div>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        categoriesList: state.entity.categoriesList || [],
        campaignsList: state.entity.campaignList || [],
        priceMatrices: state.entity.priceMatricesList,
        products: state.entity.productList || [],
        productsAll: state.entity.productListAll || [],
        addToMenuType: state.form.AddToMenuType,
        productsLength: state.entity.productListLength,
        branchId: state.common.branchId,
        webBranchId: state.common.webBranchId,
        saveSuccess: state.form[`${componentName}SaveSuccess`],
        saveError: state.form[`${componentName}SaveSuccessSaveError`],
        productsListEdit: state.form[`${componentName}Products`],
        categoriesListEdit: state.form[`${componentName}ProductCategories`],
        campaignsListEdit: state.form[`${componentName}ProductCampaigns`],
        dialogSearchProductType: state.form[`${componentName}DialogSearchProductType`],
        productSearchText: state.form[`${componentName}ProductSearchText`],
        categoryIdSearch: state.form[`${componentName}CategoryIdSearch`] ? parseInt(state.form[`${componentName}CategoryIdSearch`]) : null,
        priceMatrixIdSearch: state.form[`${componentName}PriceMatrixSearch`] ? parseInt(state.form[`${componentName}PriceMatrixSearch`]) : null,
        skuSearchText: state.form[`${componentName}SkuSearchText`],
        poSearchText: state.form[`${componentName}PoSearchText`],
        brandSearchText: state.form[`${componentName}BrandSearchText`],
        weightSearch: state.form[`${componentName}WeightSearch`] ? parseFloat(state.form[`${componentName}WeightSearch`]) : null,
        menuModel: selectCarouselForm(state, componentName),
        selectedCategoriesIds: selectCampaignSelectedCategories(state.form, componentName),
        selectedCampaignIds: selectedCampaigns(state.form, componentName),
        isMedical: state.common.applicationSettings.isMedical,
        carouselStartDate: state.form[`${componentName}CarouselStartDate`],
        carouselEndDate: state.form[`${componentName}CarouselEndDate`],
        homeSettingList: state.form.homeSettingList,
        newCarousel: state.form.carouselSaveProductGroup,
        productGroupList: state.entity.productGroupList,
        homeSettingsUpdated: state.form.homeSettingsUpdated
    };
};

function mapDispatchToProps(dispatch) {
    return {
        getCategories: () => dispatch(getCategories(parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH')))),
        getAllOnlineCampaigns: (model) => dispatch(getAllOnlineCampaigns(model)),
        getProducts: (model) => dispatch(getProductsCarousel(model)),
        saveProductGroup: (model) => dispatch(saveProductGroup(model)),
        getProductGroupById: (model) => dispatch(getProductGroupById(model)),
        getPriceMatrices: () => dispatch(getPriceMatrices()),
        showPatientError: (message) => dispatch({ type: types.DIALOG_ALERT_OPEN, message: message }),
        showProductGroupCreated: (message) => dispatch({ type: types.SNACKBAR_SHOW_MESSAGE, message: message }),
        init: () => dispatch(initializeCarouselProductGroupForm(componentName)),
        clearDialogItemsProductGroup: () => dispatch(clearDialogItemsProductGroup(componentName)),
        formError: (name, error) => dispatch(formError(name, error)),
        showError: (message) => dispatch(showError(message)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        clearProductsCarousel: () => dispatch(clearProductsCarousel()),
        getHomeSettings: branchId => dispatch(getHomeSettings(branchId)),
        updateHomeSettings: model => dispatch(updateHomeSettings(model)),
        getProductGroupHome: model => dispatch(getProductGroupHome(model)),
        updateProductCampaigns: (campaigns, compName) => dispatch(updateProductCampaigns(campaigns, compName))
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(carouselSave));
